import { Switch, Route, Redirect, useHistory} from 'react-router-dom'
import { useEffect } from 'react';

// Components
import Head from '../components/head/head'
import Dashboard from '../containers/dashboard/dashboard'
import Edit from '../containers/edit/edit'
import PopinSource from '../components/popinSource/popinSource';
import PopinReview from '../components/popinReview/popin_review';
import Admin from '../containers/admin/admin'

// Hooks 
import {  useAppDispatch, useAppSelector } from '../misc/hooks'

// Actions
import { getToken } from '../slice/token'
import {  getShopifyStoreInfo } from '../slice/shopifyStore'

function Index() {
	const dispatch = useAppDispatch()
	const history = useHistory();

	const token: string = useAppSelector((state) => state.token.token)
	const error: string = useAppSelector((state) => state.token.error)
	const source: boolean | undefined = useAppSelector((state) => state.shopifyStore?.shopifyStore?.source)
	const review: boolean | undefined = useAppSelector((state) => state.shopifyStore?.shopifyStore?.review)
	const admin: boolean | undefined = useAppSelector((state) => state.shopifyStore?.shopifyStore?.admin)

	// Effect
	useEffect(() => {
		// In case of an error
		if (error === 'reco') {
			history.push('/login')
			return
		}

		// Get token once
		if (!token && (error !== 'reco')) { 
			dispatch(getToken())
		}
		// Apply needed request once they have a token
		else if (token) {
			// Get the info of the Shopify Store
			dispatch(getShopifyStoreInfo())
			const script = document.createElement("script");
			script.type = "text/javascript";
			script.innerHTML = `window.$crisp=[];window.CRISP_WEBSITE_ID="a452521b-03c8-4796-9512-a1b069a080bf";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();`;
			document.body.appendChild(script);
		}
		
		
	}, [dispatch, token, error, history]);

	useEffect(() => {
		// Checktoken every 2 hours
		const intervalId = setInterval(() => {
			dispatch(getToken())
		}, 2 * 60 * 60 * 1000); // every 2 hours
		

		// Clean interval after component unmounted
		return () => clearInterval(intervalId);
	}, [dispatch]);

	return (
		<div className="index">
			{token ? 
				<>
					<Head/>
					<Switch>
						<Route exact path="/" component={Dashboard}/>
						<Route path="/abtest/edit/:abtest_id" component={Edit}/>
						<Route
							path="/admin"
							render={() =>
								admin === true ?  <Admin /> : admin === false ?<Redirect to="/"/> : <></> 
							}
						/>
						<Redirect to="/" />
					</Switch>

					{source === false ? 
						/*Popin to ask where user come from */ 
						<PopinSource />
					: ''}

					{review === true ? 
						<PopinReview />
					: ''}

					
				</>
			: ''}
		</div> 
	);
}

export default Index;
